import type * as Schema from 'src/types/graphql';

import type { ProfileVisibilityOptions } from './types';
import { getOptionFromProfileVisibilityId } from './utils';

export const generateUpdateProfileVisibilityOptimisticResponse2 =
  (_id: string, profileVisibilityOptions: ProfileVisibilityOptions) =>
  ({ input }: Schema.UpdateProfileVisibility2MutationVariables) => {
    const {
      __typename,
      label: name,
      id,
    } = getOptionFromProfileVisibilityId(
      profileVisibilityOptions,
      input.id,
    ) ?? {
      id: 'Hidden',
      __typename: 'HiddenVisibilityOption',
      label: 'Hidden',
    }; // Fallback to Hidden option if not found
    return {
      __typename: 'Mutation' as const,
      updateProfileVisibility2: {
        __typename: 'UpdateProfileVisibility2Success' as const,
        viewer: {
          _id,
          __typename: 'Candidate' as const,
          profileVisibility2: {
            id,
            name,
            __typename,
          },
        },
      },
    };
  };
